export default __webpack_public_path__ + "static/media/pickup-created.6870c777.png";